module.exports = __webpack_public_path__ + "static/media/credit-line.a9e836b5.png";